<router-outlet></router-outlet>
<app-toast></app-toast>
@if (!isSidenavContentLoaded()) {
<div class="fixed bottom-3 left-3 z-[900]">
    <app-chatbot-button></app-chatbot-button>
</div>
}
<app-footer-popin></app-footer-popin>
